<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>上传视频</div>
                <div style="cursor: pointer;" @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-cen">
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">视频名称<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <el-input v-model="form.title" clearable placeholder="请输入视频名称"></el-input>
                        </div>
                    </div>
                    <div class="mask-content-body-select mask-content-body-select2">
                        <div class="mask-content-body-select-title">活动视频<span>*</span>：</div>
                        <div class="mask-content-body-select-input" v-if="fileList.length == 0">
                            <el-upload class="avatar-uploader" :action="uploadfile" list-type="picture-card"
                                :on-remove="handleRemove" :headers="headers" accept=".mp4, .avi, .mov, .mkv"
                                :show-file-list="true" :file-list="fileList" :on-success="handleAvatarSuccess"
                                :limit="1" :on-exceed="handleExceed" :before-upload="beforeAvatarSuccess">
                                <div class="el-upload__tip">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                    <span class="avatar-uploader-text">点击上传视频</span>
                                </div>
                            </el-upload>
                        </div>
                        <div class="mask-content-body-select-video" v-else>
                            <video :src="fileList[0].url" controls></video>
                        </div>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleAgain">重置</div>
                    <div @click="handleSubmit">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            urls: this.imgurl,
            type: '',

            headers: {
                token: localStorage.getItem("token"),
            },
            fileList: [],

            form: {
                activity_id: '',
                title: '',
                fileurl: ''
            }
        };
    },
    mounted() {
    },
    methods: {
        handleAgain() {
            this.form.title = ''
            this.form.fileurl = ''
            this.fileList = []
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("addVideoCall", data);
        },
        async handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                data: this.form
            }
            this.$emit("addVideoCall", data);
        },
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 1) {
                fileList.forEach((item, index) => {
                    if (item.uid == file.uid) {
                        item.url = this.urls + res.data.file
                    }
                })
                this.fileList = fileList
            }
        },
        beforeAvatarSuccess(file) {
            const isVideo = file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/mov' || file.type === 'video/mkv';
            if (!isVideo) {
                this.$message.error("只能上传视频！");
                return false;
            }
            return isVideo;
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
            console.log(file, fileList);
        },
        //图片超出限制
        handleExceed(files, fileList) {
            this.fileList = fileList
            this.$message.warning("图片个数超出限制");
        },

    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.type = newVal.type
                    this.form = newVal.data

                    let videolist = this.form.fileurl ? this.form.fileurl.split(',') : []
                    let fileList = []
                    videolist.forEach((item, index) => {
                        fileList.push({
                            name: '',
                            percentage: 100,
                            raw: {},
                            response: {},
                            size: 1206,
                            status: "success",
                            uid: 1758180136738 + index,
                            url: this.urls + item
                        })
                    })
                    this.fileList = fileList
                }
            },
            deep: true
        },
        fileList: {
            handler(newVal, oldVal) {
                let imagelist = []
                newVal.forEach(item => {
                    if (item.status == "success") {
                        let url = item.url.replace(this.urls, '')
                        imagelist.push(url)
                    }
                })
                this.form.fileurl = imagelist.toString()
                console.log(this.form.fileurl, this.form)
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 715px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #FFF;
            padding: 20px 20px 34px 20px;

            .mask-content-body-cen {
                width: 100%;
                min-height: 550px;

                .mask-content-body-select {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    margin-bottom: 20px;

                    .mask-content-body-select-title {
                        width: 87px;
                        color: #A6A6A6;
                        font-size: 14px;
                        display: flex;
                        align-items: center;

                        span {
                            color: #C12E30;
                        }
                    }

                    /deep/ .mask-content-body-select-input {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-top: 10px;

                        .el-select {
                            flex: 1;
                        }

                        .el-date-editor {
                            flex: 1;
                        }

                        .mask-content-body-select-input-span {
                            width: 30px;
                            color: #A6A6A6;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .avatar-uploader {
                            .el-upload {
                                border: 1px dashed #DCDCDC;
                                background: #E7E7E7;
                            }
                        }

                        .el-upload__tip {
                            width: 100%;
                            height: 100%;
                            flex-direction: column;
                            @include flex-center(center, center);

                            .avatar-uploader-text {
                                color: rgba(0, 0, 0, 0.40);
                                font-size: 12px;
                                line-height: normal;
                                margin-top: 10px;
                            }
                        }

                        .upload-demo {
                            width: 100%;

                            .el-upload {
                                width: 100%;

                                .el-upload-dragger {
                                    width: 100%;
                                    height: 50px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }
                            }
                        }
                    }

                    .mask-content-body-select-video {
                        width: 675px;
                        height: 347px;

                        video {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .mask-content-body-select2 {
                    display: flex;
                    align-items: normal;

                    .mask-content-body-select-title {
                        align-items: normal;
                        line-height: 40px;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 27px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #eb686a;
                    }

                    &:nth-child(3) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}

.el-date-picker {
    z-index: 9999 !important;
}
</style>